import styled from 'styled-components';

import { getPurpurColor, getPurpurTypography } from '@telialt/common-theme/src/purpurSelectors';

export const LocalCode = styled.span`
    user-select: all;
    font-size: ${getPurpurTypography('scale75')};
    color: ${getPurpurColor('textInteractiveSelected')};
    word-break: break-all;
    width: fit-content;
`;
